import React, { useEffect, useState } from "react";
import {
    Grid,
    GridRow,
    GridColumn,
    LabeledText,
    Stack,
    Text,
    Shimmer,
    LabeledDate,
    depascalize
} from "sprint-common-web";

import { GetCloudFileStatusDetailsResponse } from "../../../../../common/api/master-api/cloud-files/get-status/GetCloudFileStatusDetailsResponse";
import { useCloudFileApi } from "../../../../../common/api/master-api/cloud-files/useCloudFileApi";
import { renderCloudFileStatusDetailsText } from "../../../common/utils/renderCloudFileStatus";

export interface CloudFileStatusDetailsAsideContentProps {
    cloudFileId: string;
}

export const CloudFileStatusDetailsAsideContent: React.FunctionComponent<CloudFileStatusDetailsAsideContentProps> = (
    props: CloudFileStatusDetailsAsideContentProps
) => {
    const { cloudFileId } = props;

    const { getCloudFileStatus } = useCloudFileApi();

    const [data, setData] = useState<GetCloudFileStatusDetailsResponse | undefined>();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    useEffect(() => {
        setIsLoading(true);

        getCloudFileStatus({ cloudFileId })
            .then((response: GetCloudFileStatusDetailsResponse) => {
                setData(response);
            })
            .finally(() => setIsLoading(false));
    }, [cloudFileId]);

    if (isLoading) {
        return (
            <Stack styles={{ root: { paddingTop: 20 } }} tokens={{ childrenGap: "l1" }}>
                <Shimmer width="30%" />
                <Shimmer width="50%" />
                <Shimmer width="30%" />
                <Shimmer width="50%" />
                <Shimmer width="30%" />
                <Shimmer width="50%" />
            </Stack>
        );
    }

    if (!data) {
        return (
            <Stack styles={{ root: { margin: 20 } }}>
                <Text>Could not load requested data</Text>
            </Stack>
        );
    }

    return (
        <Grid>
            <GridRow style={{ paddingBottom: 20 }}>
                <GridColumn sm={12}>
                    <LabeledText label="File name" value={data.fileName} textTooltip={true} />
                    <LabeledDate label="Arrival date" value={new Date(data.arrivalDate)} />
                </GridColumn>
            </GridRow>
            <GridRow style={{ paddingBottom: 20 }}>
                <GridColumn sm={12}>
                    <LabeledText label="Status" value={depascalize(data.status)} />
                    {renderCloudFileStatusDetailsText(data.statusDetails)}
                </GridColumn>
            </GridRow>
        </Grid>
    );
};
